import { getColumns } from "./column";
import { getRows } from "./row";

const getTitle = node => node?.column_name ?? node?.id?.slice(1);

const getTableData = (selectedNode, graphMap, driverMap) => {
  const node = driverMap[selectedNode.data.label] || driverMap[selectedNode.id];
  const title = getTitle(node) ?? selectedNode.data.label;
  const columns = getColumns(node, graphMap);
  const rows = getRows(node, graphMap, driverMap);
  rows?.sort((a, b) => b.score - a.score);
  return { title, columns, rows };
};

export { getTableData };
